import API from '@/views/Fdc/Apis/'
import Modal from '@/views/Fdc/EqpInfo/Components/Modal'
// import common from '../EqpInfoCommon.script.js'

/**
 * EQP Info > Recipe Manager
 * Recipe / Step 정보 관리
 */
export default {
  name: 'RecipeManager',
  components: {
    'modal': Modal // Edit / Add Modal
  },
  watch: {
  },
  beforeMount () {
    this.initColumns()
  },
  methods: {
    initColumns () {
      this.columnsRecipe = [
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 100, required: true, modifiable: false, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 100, required: true, modifiable: false, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 150, required: true, modifiable: false, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP_COUNT'), field: 'stepCount', width: 100, editable: false, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MAX_PROCESS_TIME'), field: 'maxProcTime', width: 150, required: true, modifiable: false, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', width: 90, required: true, modifiable: false, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), field: 'recipeDesc', width: 150, modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 160, editable: false, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110, editable: false }
      ]
      this.columnsStep = [
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 100, required: true, modifiable: false, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 100, required: true, modifiable: false, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'stepId', width: 120, required: true, modifiable: false, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.START_SETTLING_TIME') + ' (s)', field: 'startSettlingTime', width: 150, type: 'numericColumn', modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.END_SETTLING_TIME') + ' (s)', field: 'endSettlingTime', width: 150, type: 'numericColumn', modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.ACTIVATION_TIME'), field: 'activationTime', width: 130, required: true, type: 'numericColumn', modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', width: 90, required: true, modifiable: false, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), field: 'stepDesc', width: 150, modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 160, editable: false, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110, editable: false }
      ]
    },
    /**
     * Recipe 목록 조회
     * @param {String} fab fab
     * @param {String} eqpId EQP ID
     * @param {String} moduleId Module ID
     */
    async listFn (fab, eqpId, moduleId) {
      let payload = {
        fab: fab,
        eqpId: eqpId,
        moduleId: moduleId
      }
      let data = await API.BaseInfo.getEqpRecipes(payload)

      this.rowDataRecipe = data
      this.rowDataStep = []
      this.selectedRecipeId = null
      // this.recipeManagerGrid.select(-1, -1)
    },
    /**
     * Step 목록 조회
     * @param {String} fab fab
     * @param {String} eqpId EQP ID
     * @param {String} moduleId Module ID
     * @param {String} recipeId Recipe ID
     */
    async listFnStep (fab, eqpId, moduleId, recipeId) {
      if (recipeId !== undefined) {
        let payload = {
          fab: fab,
          eqpId: eqpId,
          moduleId: moduleId,
          recipeId: recipeId
        }
        let data = await API.BaseInfo.getEqpRecipeSteps(payload)

        this.rowDataStep = data
      }
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * Recipe 검색
     */
    searchProcess () {
      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Equipment']))
        return
      }
      let node = this.selectedTreeNode
      if (node.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Module ID']))
        return
      }
      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      this.listFn(
        node.detail.fab,
        node.detail.eqpId,
        node.detail.moduleId
      )
    },
    /**
     * Recipe Grid Row Select method
     * @param {*} rows selection rows
     */
    recipeGridSelected (rows) {
      if (rows.length === 1) {
        let node = this.searchTreeNode
        let recipeId = rows[0].recipeId
        let isNew = rows[0].isNew

        if (this.selectedRecipeId !== recipeId && !isNew) {
          this.selectedRecipeId = recipeId
          this.listFnStep(
            node.detail.fab,
            node.detail.eqpId,
            node.detail.moduleId,
            recipeId
          )
        }

        if (isNew) {
          // this.stepAddDisabled = true
          this.rowDataStep = []
          this.selectedRecipeId = null
        }
      } else {
        // this.stepAddDisabled = true
        this.rowDataStep = []
        this.selectedRecipeId = null
      }
    },
    // recipeGridSelected (grid) {
    //   if (grid.selectedItems.length === 1) {
    //     let node = this.searchTreeNode
    //     let recipeId = grid.selectedItems[0].recipeId
    //     let isNew = grid.selectedItems[0].isNew

    //     if (this.selectedRecipeId !== recipeId && !isNew) {
    //       this.selectedRecipeId = recipeId
    //       this.listFnStep(
    //         node.detail.fab,
    //         node.detail.eqpId,
    //         node.detail.moduleId,
    //         recipeId
    //       )
    //     }

    //     if (isNew) {
    //       // this.stepAddDisabled = true
    //       this.rowDataStep = []
    //       this.selectedRecipeId = null
    //     }
    //   } else {
    //     // this.stepAddDisabled = true
    //     this.rowDataStep = []
    //     this.selectedRecipeId = null
    //   }
    // },
    /**
     * Recipe Manager Grid에 check된 row count 확인
     * @returns {Boolean} check된 row가 있는지 여부
     */
    hasCheckedRowsRecipe () {
      if (!this.$refs.recipeManagerGrid) {
        return 0
      }
      return this.$refs.recipeManagerGrid.checkedRowCount > 0
    },
    /**
     * Add Button 활성화 여부 결정
     * @returns {Boolean} Add Button 활성화 여부
     * 검색된 tree node 있는지 여부를 판단하여 Add Button 활성화 여부를 결정합니다.
     */
    existRowsRecipe () {
      if (!this.searchTreeNode.detail) {
        return false
      } else {
        let selectEqpVo = this.searchTreeNode.detail
        if (selectEqpVo.fab !== null &&
          selectEqpVo.eqpId !== null &&
          selectEqpVo.moduleId !== null) {
          return true
        }
        return false
      }
    },
    /**
     * Recipe / Step Add Modal 열기
     */
    newRowAddRecipe () {
      this.recipeSaveModal.visible = true
      this.modalTitle = this.$t('fdc.EQP_INFO.TITLE.T0016')
      this.initAddRecipeModal()
    },
    /**
     * Step Manager Grid에 check된 row count 확인
     * @returns {Boolean} check된 row가 있는지 여부
     */
    hasCheckedRowsStep () {
      if (!this.$refs.stepManagerGrid) {
        return 0
      }
      return this.$refs.stepManagerGrid.checkedRowCount > 0
    },
    // newRowAddStep () {
    //   let selectEqpVo = this.searchTreeNode.detail
    //   let recipeId = this.recipeManagerGrid.selectedItems[0].recipeId
    //   let arr = [
    //     {
    //       fab: selectEqpVo.fab,
    //       eqpId: selectEqpVo.eqpId,
    //       moduleId: selectEqpVo.moduleId,
    //       recipeId: recipeId,
    //       stepDesc: '',
    //       startSettlingTime: 0,
    //       endSettlingTime: -1,
    //       activationTime: -1,
    //       useYn: 'Y',
    //       isNew: true
    //     }
    //   ]
    //   let status = {
    //     checked: true,
    //     modified: false,
    //     added: true
    //   }
    //   this.$refs.stepManagerGrid.addRows(arr, status)
    // },
    // newRowAddStepEdit () {
    //   const newStepCount = this.$refs.stepEditGrid.grid.rows.length + 1

    //   let arr = [
    //     {
    //       fab: this.checkedRow.fab,
    //       eqpId: this.checkedRow.eqpId,
    //       moduleId: this.checkedRow.moduleId,
    //       recipeId: this.checkedRow.recipeId,
    //       startSettlingTime: 0,
    //       endSettlingTime: -1,
    //       activationTime: -1,
    //       useYn: 'Y',
    //       isNew: true
    //     }
    //   ]
    //   let status = {
    //     checked: true,
    //     modified: false,
    //     added: true
    //   }
    //   this.$refs.stepEditGrid.addRows(arr, status)

    //   // recipe info의 stepCount를 갱신
    //   let recipeInfo = this.$refs.recipeEditGrid.grid.rows[0].dataItem
    //   recipeInfo.stepCount = newStepCount
    //   this.rowDataRecipeEdit = [recipeInfo]
    // },
    // updateComboBoxInGrid () {
    //   if (this.recipeEditGrid) {
    //     let colUseYn = this.recipeEditGrid.columns.getColumn('useYn')
    //     if (colUseYn) {
    //       colUseYn.dataMapEditor = true
    //       colUseYn.dataMap = this.buildDataMap(this.useYnList, 'useYn')
    //     }
    //   }
    // },
    // updateComboBoxInGridStep () {
    //   if (this.stepEditGrid) {
    //     let colUseYn = this.stepEditGrid.columns.getColumn('useYn')
    //     if (colUseYn) {
    //       colUseYn.dataMapEditor = true
    //       colUseYn.dataMap = this.buildDataMap(this.useYnList2, 'useYn')
    //     }
    //   }
    // },
    // buildDataMap (items, keyName) {
    //   let map = []
    //   for (let i = 0; i < items.length; i++) {
    //     map.push({ key: items[i][keyName], value: items[i][keyName] })
    //   }
    //   return new wjcGrid.DataMap(map, 'key', 'value')
    // },
    /**
     * Recipe Manager Grid 재조회
     */
    refreshGrid () {
      if (this.searchTreeNode && this.searchTreeNode.length !== 0) {
        let selectEqpVo = this.searchTreeNode.detail
        this.listFn(selectEqpVo.fab, selectEqpVo.eqpId, selectEqpVo.moduleId)
      }
    },
    // refreshGridEditRecipe () {
    //   this.rowDataRecipeEdit = this.rowInitDataRecipeEdit.map(rowData => Object.assign({}, rowData))
    // },
    // refreshGridEditStep () {
    //   this.rowDataStepEdit = this.rowInitDataStepEdit.map(rowData => Object.assign({}, rowData))

    //   // recipe info의 stepCount를 초기화
    //   const currentStepCount = this.rowDataStepEdit.length
    //   let recipeInfo = this.$refs.recipeEditGrid.grid.rows[0].dataItem
    //   recipeInfo.stepCount = currentStepCount
    //   this.rowDataRecipeEdit = [recipeInfo]
    // },
    /**
     * Recipe / Step Edit Modal 열기
     */
    editRecipeRow () {
      this.recipeSaveModal.visible = true
      this.modalTitle = this.$t('fdc.EQP_INFO.TITLE.T0015')
      this.initEditRecipeModal()
    },
    // async cellEditEnd (grid, event) {
    //   let col = grid.columns[event.col]
    //   let rowData = grid.rows[event.row]._data
    //   let rowStatus = grid.rows[event.row]._data._status

    //   // useYn을 변경했을때 모든 recipeStep의 useYn도 동일하게 변경
    //   const binding = this.columnsRecipeEdit[col._idx].binding

    //   if(binding === "useYn") {
    //     const newValue = rowData[binding]
    //     this.rowDataStepEdit = this.rowDataStepEdit.map(rowData => {
    //       const rowDataCopy = Object.assign({}, rowData)
    //       rowDataCopy[binding] = newValue
    //       return rowDataCopy
    //     })
    //   }

    //   // modified and added row 시 자동 check (checkbox column 제외)
    //   if (col.binding !== '_status.checked') {
    //     if (rowStatus.modified || rowStatus.added) {
    //       rowStatus.checked = true
    //     }
    //     // else {
    //     //   rowStatus.checked = false
    //     // }
    //   }

    //   // key validation
    //   if (rowData.isNew && rowData.eqpId && rowData.moduleId && rowData.recipeId) {
    //     if (col.binding === 'recipeId') {
    //       let payload = {
    //         fab: rowData.fab,
    //         eqpId: rowData.eqpId,
    //         moduleId: rowData.moduleId,
    //         recipeId: rowData.recipeId
    //       }
    //       let result = await API.FdcEqpInfo.recipeKeyValidation(payload)
    //       if (result > 0) {
    //         this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['KEY']))
    //         rowData.recipeId = null
    //       } else {
    //         if (!this.newRowsKeyValidation(payload)) {
    //           this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['KEY']))
    //           rowData.recipeId = null
    //         }
    //       }
    //     }
    //   }
    // },
    /**
     * Recipe 삭제
     * 실제 삭제가 아니라 Use YN만 'N'으로 변경합니다.
     */
    async deleteDataRecipe () {
      let self = this
      // let allRows = this.$refs.recipeManagerGrid.grid.rows
      // let checkedRows = common.getCheckedRows(allRows)
      const checkedRows = this.$refs.recipeManagerGrid.getCheckedRows()

      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Item']))
        return
      }

      let mustDeleteRows = []

      for (let i in checkedRows) {
        let isCreate = true
        if (!checkedRows[i].isNew) {
          isCreate = false
        }
        var data = checkedRows[i]
        if (!isCreate) {
          mustDeleteRows.push(data)
        }
      }

      let message = (mustDeleteRows.length) + ' ' + this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_DELETE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function deleteLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE'))
              let node = self.searchTreeNode
              self.listFn(node.detail.fab, node.detail.eqpId, node.detail.moduleId)
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_DELETE'))
            }
          }

          if (mustDeleteRows.length > 0) {
            API.BaseInfo.putEqpRecipe(mustDeleteRows).then(result => {
              deleteLastProcess(result)
            })
          }
        },
        onCancel: function () {}
      })
    },
    // async cellEditEndStep (grid, event) {
    //   let col = grid.columns[event.col]
    //   let rowData = grid.rows[event.row]._data
    //   let rowStatus = grid.rows[event.row]._data._status

    //   // 값을 변경한 row가 checked 상태일때 다른 checked row도 동일한 값으로 변경
    //   if(rowStatus.checked) {
    //     let allRows = this.$refs.stepEditGrid.grid.rows
    //     let checkedRows = common.getCheckedRows(allRows)
    //     const checkedStepIdList = checkedRows.map(checkedRow => checkedRow.stepId)
    //     const binding = this.columnsStepEdit[col._idx].binding
    //     const newValue = rowData[binding]

    //     if(checkedStepIdList.length > 1 && binding !== 'eqpId' && binding !== 'moduleId' && binding !== 'stepId') {
    //       this.rowDataStepEdit = this.rowDataStepEdit.map(rowData => {
    //         if(checkedStepIdList.find(checkedStepId => checkedStepId === rowData.stepId)) {
    //           const rowDataCopy = Object.assign({}, rowData)
    //           rowDataCopy[binding] = newValue
    //           return rowDataCopy
    //         }

    //         return rowData
    //       })
    //     }
    //   }

    //   // modified and added row 시 자동 check (checkbox column 제외)
    //   if (col.binding !== '_status.checked') {
    //     if (rowStatus.modified || rowStatus.added) {
    //       rowStatus.checked = true
    //     }
    //     // else {
    //     //   rowStatus.checked = false
    //     // }
    //   }

    //   // key validation
    //   if (rowData.isNew && rowData.eqpId && rowData.moduleId && rowData.recipeId && rowData.stepId) {
    //     if (col.binding === 'stepId') {
    //       let payload = {
    //         fab: rowData.fab,
    //         eqpId: rowData.eqpId,
    //         moduleId: rowData.moduleId,
    //         recipeId: rowData.recipeId,
    //         stepId: rowData.stepId
    //       }
    //       let result = await API.FdcEqpInfo.stepKeyValidation(payload)
    //       if (result > 0) {
    //         this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['KEY']))
    //         rowData.stepId = null
    //       } else {
    //         if (!this.newRowsKeyValidation(payload)) {
    //           this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['KEY']))
    //           rowData.stepId = null
    //         }
    //       }
    //     }
    //   }
    // },
    /**
     * Step 삭제
     * 실제 삭제가 아니라 Use YN만 'N'으로 변경합니다.
     */
    async deleteDataStep () {
      let self = this
      // let allRows = this.$refs.stepManagerGrid.grid.rows
      // let checkedRows = common.getCheckedRows(allRows)
      const checkedRows = this.$refs.stepManagerGrid.getCheckedRows()

      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Item']))
        return
      }

      let mustDeleteRows = []

      for (let i in checkedRows) {
        let isCreate = true
        if (!checkedRows[i].isNew) {
          isCreate = false
        }
        var data = checkedRows[i]
        if (!isCreate) {
          mustDeleteRows.push(data)
        }
      }

      let message = (mustDeleteRows.length) + ' ' + this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_DELETE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function deleteLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE'))
              let node = self.searchTreeNode
              let recipeId = mustDeleteRows[0].recipeId

              self.listFnStep(
                node.detail.fab,
                node.detail.eqpId,
                node.detail.moduleId,
                recipeId
              )
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_DELETE'))
            }
          }

          if (mustDeleteRows.length > 0) {
            API.BaseInfo.putEqpRecipeStep(mustDeleteRows).then(result => {
              deleteLastProcess(result)
            })
          }
        },
        onCancel: function () {}
      })
    },
    // deleteDataStepEdit () {
    //   let allRows = this.$refs.stepEditGrid.grid.rows
    //   let checkedRows = common.getCheckedRows(allRows)

    //   const checkedStepIdList = checkedRows.map(checkedRow => checkedRow.stepId)

    //   this.rowDataStepEdit = this.rowDataStepEdit.map(rowData => {
    //     if (checkedStepIdList.find(checkedStepId => checkedStepId === rowData.stepId)) {
    //       const rowDataCopy = Object.assign({}, rowData)
    //       rowDataCopy.useYn = 'N'
    //       return rowDataCopy
    //     }

    //     return rowData
    //   })
    // },
    // newRowsKeyValidation (params) {
    //   let allRows = []
    //   if (params.stepId) {
    //     allRows = this.$refs.recipeManagerGrid.grid.rows
    //   } else {
    //     allRows = this.$refs.stepManagerGrid.grid.rows
    //   }
    //   let addedRows = common.getAddedRows(allRows)
    //   let result = true
    //   let sameDataCnt = 0
    //   for (var i in addedRows) {
    //     if (params.stepId) {
    //       if (addedRows[i].fab === params.fab &&
    //         addedRows[i].eqpId === params.eqpId &&
    //         addedRows[i].moduleId === params.moduleId &&
    //         addedRows[i].recipeId === params.recipeId &&
    //         addedRows[i].recipeId) {
    //         // result = false
    //         // break
    //         sameDataCnt++
    //       }
    //     } else {
    //       if (addedRows[i].fab === params.fab &&
    //         addedRows[i].eqpId === params.eqpId &&
    //         addedRows[i].moduleId === params.moduleId &&
    //         addedRows[i].recipeId === params.recipeId &&
    //         addedRows[i].stepId === params.stepId &&
    //         addedRows[i].stepId) {
    //         // result = false
    //         // break
    //         sameDataCnt++
    //       }
    //     }
    //   }
    //   if (sameDataCnt > 1) {
    //     result = false
    //   }
    //   return result
    // },
    /**
     * Excel Export
     * @param {String} division grid 구분자
     * 조회된 결과를 Excel 파일로 저장합니다.
     */
    exportExcel (division) {
      // if (division === 'recipe') this.$refs.recipeManagerGrid.exportExcel('RecipeManager')
      // else if (division === 'step') this.$refs.stepManagerGrid.exportExcel('StepManager')
      if (division === 'recipe') this.$refs.recipeManagerGrid.gridApi.exportDataAsCsv({ fileName: 'RecipeManager.csv' })
      else if (division === 'step') this.$refs.stepManagerGrid.gridApi.exportDataAsCsv({ fileName: 'StepManager.csv' })
    },
    /**
     * Recipe Manager Grid에 check된 row count가 1개인지 확인
     * @returns {Boolean} check된 1개인지 여부
     * Edit 가능 여부에 대해서 판단하여 button 활성화 값이 달라집니다.
     */
    hasOneCheckedRow () {
      if (!this.$refs.recipeManagerGrid) {
        return 0
      }
      return this.$refs.recipeManagerGrid.checkedRowCount === 1
    },
    /**
     * Recipe / Step Edit Modal 초기 data 설정
     */
    initEditRecipeModal () {
      // const rows = this.$refs.recipeManagerGrid.grid.rows.filter(row => row.dataItem._status)
      // const checkedRowData = rows.find(row => row.dataItem._status.checked).dataItem
      const checkedRowData = this.$refs.recipeManagerGrid.getCheckedRows()[0]
      let initObj = {
        saveType: 'Edit',
        recipeList: [
          Object.assign({}, checkedRowData)
        ]
      }
      this.initValue = initObj
    },
    /**
     * Recipe / Step Add Modal 초기 data 설정
     */
    initAddRecipeModal () {
      let node = this.searchTreeNode
      let initObj = {
        saveType: 'Add',
        recipeList: [
          {
            fab: node.detail.fab,
            eqpId: node.detail.eqpId,
            moduleId: node.detail.moduleId,
            recipeDesc: '',
            stepCount: 0,
            maxProcTime: 3600,
            useYn: 'Y',
            isNew: true
          }
        ]
      }
      this.initValue = initObj
    },
    /**
     * Recipe Add/Edit Modal data 초기화
     */
    resetRecipeModal () {
      this.initValue = {}
      let node = this.searchTreeNode
      this.listFn(
        node.detail.fab,
        node.detail.eqpId,
        node.detail.moduleId,
        node.detail.recipeId
      )
    },
    /**
     * Recipe Add/Edit Modal close
     */
    closeRecipeSaveModal () {
      this.recipeSaveModal.visible = false
    },
    // closeRecipeEditModal () {
    //   this.recipeEditModal.visible = false
    // },
    // closeRecipeAddModal () {
    //   this.addRecipeModal.visible = false
    // },
    /**
     * Edit Button click event
     * check된 row가 없는 상태에서 click 시 alert를 띄웁니다.
     */
    clickDisabledEditButton () {
      if (this.$refs.recipeManagerGrid.checkedRowCount !== 1) {
        this.$dialog.alert('Check a row to edit Recipe')
      }
    }
  },
  data () {
    return {
      recipeManagerGrid: null, // Recipe Manager Grid 객체
      stepManagerGrid: null, // Step Manager Grid 객체
      // columnsRecipe: [
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', width: 100, required: true, modifiable: false, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', width: 100, required: true, modifiable: false, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', width: 100, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.STEP_COUNT'), binding: 'stepCount', width: 100, readOnly: true, dataType: 'Number' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MAX_PROCESS_TIME'), binding: 'maxProcTime', width: 150, required: true, modifiable: false, dataType: 'Number' },
      //   { label: this.$t('fdc.COMMON.COLUMN.USABLE'), binding: 'useYn', width: 90, required: true, modifiable: false, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), binding: 'recipeDesc', width: 150, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), binding: 'modifyDt', width: 160, readOnly: true, dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), binding: 'modifyUser', width: 110, readOnly: true }
      // ], // Recipe Manager grid column 배열
      // columnsStep: [
      //   { label: this.$t('fdc.COMMON.COLUMN.EQP_ID'), binding: 'eqpId', width: 100, required: true, modifiable: false, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), binding: 'moduleId', width: 100, required: true, modifiable: false, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.STEP'), binding: 'stepId', width: 90, required: true, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.START_SETTLING_TIME') + ' (s)', binding: 'startSettlingTime', width: 150, dataType: 'Number', modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.END_SETTLING_TIME') + ' (s)', binding: 'endSettlingTime', width: 150, dataType: 'Number', modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.ACTIVATION_TIME'), binding: 'activationTime', width: 130, required: true, dataType: 'Number', modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.USABLE'), binding: 'useYn', width: 90, required: true, modifiable: false, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), binding: 'stepDesc', width: 150, modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), binding: 'modifyDt', width: 160, readOnly: true, dataType: 'Date', format: 'yyyy-MM-dd HH:mm:ss' },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), binding: 'modifyUser', width: 110, readOnly: true }
      // ], // Step Manager grid column 배열
      columnsRecipe: [], // Recipe Manager grid column 배열
      columnsStep: [], // Step Manager grid column 배열
      defaultColDef: {
        minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      rowDataRecipe: [], // Recipe Manager grid row data
      rowDataStep: [], // Step Manager grid row data
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색한 EQP Tree node
      // useYnList: [
      //   { useYn: 'Y' },
      //   { useYn: 'N' }
      // ],
      // useYnList2: [
      //   { useYn: 'Y' },
      //   { useYn: 'N' }
      // ],
      // stepAddDisabled: true,
      selectedRecipeId: null, // 선택된 Recipe Manager Grid의 Recipe ID
      modalTitle: '', // Recipe/Step Save Modal Title
      initValue: {}, // Recipe/Step Save Modal 초기 data
      recipeSaveModal: {
        visible: false
      } // Recipe/Step Save Modal 표시 여부
    }
  }
}
